/** Decode literal \uXXXX escape sequences stored as text (e.g. "AC\u2085\u2080" → "AC₅₀") */
export const decodeUnicodeEscapes = (s: string): string =>
  s.replace(/\\u([0-9a-fA-F]{4})/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
